import { render, staticRenderFns } from "./TableCancelacionesPendientes.vue?vue&type=template&id=1c013d50&scoped=true"
import script from "./TableCancelacionesPendientes.vue?vue&type=script&lang=js"
export * from "./TableCancelacionesPendientes.vue?vue&type=script&lang=js"
import style0 from "./TableCancelacionesPendientes.vue?vue&type=style&index=0&id=1c013d50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c013d50",
  null
  
)

export default component.exports